export interface PasswordRequirement {
    id: string
    label: string
    test: (password: string) => boolean
}

export const passwordRequirements: PasswordRequirement[] = [
    {
        id: 'minLength',
        label: 'minLength',
        test: (password: string) => password.length >= 8,
    },
    {
        id: 'uppercase',
        label: 'uppercase',
        test: (password: string) => /[A-Z]/.test(password),
    },
    {
        id: 'lowercase',
        label: 'lowercase',
        test: (password: string) => /[a-z]/.test(password),
    },
    {
        id: 'number',
        label: 'number',
        test: (password: string) => /\d/.test(password),
    },
    {
        id: 'special',
        label: 'special',
        test: (password: string) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
    },
]

export interface PasswordValidationResult {
    isValid: boolean
    requirements: {
        [key: string]: {
            met: boolean
            label: string
        }
    }
}

export const validatePassword = (password: string): PasswordValidationResult => {
    const requirements: { [key: string]: { met: boolean; label: string } } = {}
    let isValid = true

    passwordRequirements.forEach((requirement) => {
        const met = requirement.test(password)
        requirements[requirement.id] = {
            met,
            label: requirement.label,
        }
        if (!met) {
            isValid = false
        }
    })

    return {
        isValid,
        requirements,
    }
}

export const getPasswordStrengthScore = (password: string): number => {
    const result = validatePassword(password)
    const metRequirements = Object.values(result.requirements).filter((req) => req.met).length
    return Math.round((metRequirements / passwordRequirements.length) * 100)
}
